__webpack_public_path__ = process.env.NODE_ENV==='production' 
                            ? window.cb_hp_cdn_path : '/';